var plusCircle = "https://shopfront-cdn.tekoapis.com/static/35b9af99a5fd3532.svg";

export { plusCircle as default };
